module.exports = __webpack_public_path__ + "static/media/spacecaves-background.5612ef78.jpg";